var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"open-browser-cover",on:{"click":function($event){return _vm.closeModule()}}},[_c('img',{attrs:{"src":_vm.img[_vm.hintType],"alt":"提示"}})])}
var staticRenderFns = []

export { render, staticRenderFns }